/**
 * One number worth looking at.
 *
 * The number uses the app sans, like every heading, because it is the thing the tile exists for
 * and the label is its caption. `delta` is a short sentence under it ("3 more than last week",
 * "2 failed") with a tone: `bad` is for the admin health page, where any number above zero is a
 * problem and should look like one.
 */
export function StatTile({
  label,
  value,
  delta,
  tone = "neutral",
}: {
  label: string;
  value: string | number;
  delta?: string;
  tone?: "neutral" | "good" | "bad";
}) {
  const deltaTone = {
    neutral: "text-ink-2",
    good: "text-confirmed",
    bad: "text-cancelled",
  }[tone];

  return (
    <div
      className={[
        "rounded-card border bg-paper px-4 py-3.5 shadow-card",
        tone === "bad" ? "border-cancelled/30" : "border-line",
      ].join(" ")}
    >
      <p className="text-[11px] font-semibold tracking-[0.1em] text-ink-3 uppercase">{label}</p>
      <p
        className={[
          "mt-1 text-[28px] leading-none font-semibold tabular-nums",
          tone === "bad" ? "text-cancelled" : "text-ink",
        ].join(" ")}
      >
        {value}
      </p>
      {delta ? <p className={`mt-1.5 text-[13px] ${deltaTone}`}>{delta}</p> : null}
    </div>
  );
}
